import * as React from 'react';

import { auth } from '../../firebase';
import { fetchProductCategories } from '../dispensaries/dispensary-utils';
import { updateProductCategoriesEndpoint } from '../../constants/api-endpoints';
import DisplayModal from '../common/DisplayModal';

import PropTypes from 'prop-types';

/**
 * Component to display categories and provide a means to add a new one
 */
const UpdateCategories = () => { 
  
  const [updateMsg, setUpdateMsg] = React.useState();
  const [categoryData, setCategoryData] = React.useState();
  
  window.categoryObj = {
    "name": "accessories",
    "display_name": "Accessories",
    "image_url": "https://www.google.com"
  }; 

  // PUT or UPDATE or DELETE with special url
  window.categoryFetchType = 'PUT'; 

  const updateProductCategories = async () => {
    if (auth.currentUser) {
      auth.currentUser.getIdToken(/* no need to force refresh */ false).then(function(idToken) {
        // const deleteCategoryUrl = `${updateProductCategoriesEndpoint}/category-to-delete`;
        fetch(updateProductCategoriesEndpoint, {
          method: window.categoryFetchType,
          headers: {
            'Authorization': idToken,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(window.categoryObj)
        }).then(response => {
          if (response.status === 201) {
            setUpdateMsg(`Category added/updated!`);
          } else {
            response.json().then(body => {
              setUpdateMsg(`Error: ${body.error}`);
            });
        }}).catch(error => {
          setUpdateMsg(`Error: ${error.message}`);
        });
      });
    }
  };

  return ( 
    <div>
      <button onClick={() => fetchProductCategories(setCategoryData)}>Display Existing Categories</button>
      <button onClick={updateProductCategories}>Upload a New Category</button>
     
      { updateMsg &&
        <div>{updateMsg}</div>
      }

      {categoryData && 
        <DisplayModal title="Product Categories" closeFn={() => setCategoryData(null)}>
          { categoryData.data.map(category => {
              return (
                <div key={category.name}>
                  <span>{category.name}:{' '}</span>
                  <span>{category.display_name}</span>
                </div>);
            }) 
          }
        </DisplayModal>        
      }
    </div>
  )
}

UpdateCategories.propTypes = {
  onUpdate: PropTypes.func
}

export default UpdateCategories;